import {
  jb_apple_podcast_icon_css_default
} from "./chunk.CM5CQO7J.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.6P2PIW72.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-apple-podcast-icon/jb-apple-podcast-icon.ts
var JbApplePodcastIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23 24"
      >
        <path
          d="M13.6609 17.2905C13.6216 18.8048 13.4611 20.3009 12.9707 21.7465C12.7409 22.4245 12.4329 23.0649 11.888 23.5649C11.2553 24.1447 10.7318 24.1502 10.0954 23.5504C9.41999 22.9126 9.09837 22.0766 8.86454 21.2162C8.414 19.5582 8.29142 17.8548 8.32305 16.1475C8.34942 14.7211 9.56947 13.5848 10.9857 13.5763C12.3705 13.568 13.5325 14.6175 13.6543 16.0133C13.692 16.4359 13.6609 16.8654 13.6609 17.2905Z"
        />
        <path
          d="M8.30423 10.1752C8.29711 8.6773 9.56672 7.46305 11.125 7.47885C12.4813 7.49258 13.7009 8.74051 13.7148 10.1289C13.7293 11.5815 12.4874 12.8084 10.9995 12.8118C9.53034 12.8151 8.31214 11.6224 8.30423 10.1752Z"
        />
        <path
          d="M22.0954 9.72395C21.5381 4.08714 16.3624 -0.244225 10.4775 0.0106987C4.66934 0.262254 -0.0160398 5.09103 4.1271e-05 10.8659C0.0161223 16.6082 4.33981 20.3673 7.60189 21.168C7.49943 20.6787 7.41375 20.1875 7.34486 19.6942C7.21595 19.5299 7.02851 19.3986 6.77042 19.2771C3.11581 17.5522 0.95805 13.4325 1.59602 9.51177C2.47336 4.12056 7.55391 0.660183 13.0444 1.71381C18.125 2.68895 21.5671 7.88275 20.4145 12.8408C19.7004 15.9131 17.8837 18.1211 15.001 19.4921C14.8892 19.5452 14.7482 19.5628 14.666 19.6592C14.5953 20.1932 14.5057 20.7242 14.3923 21.2517C18.1526 20.3069 22.7244 16.0605 22.0954 9.72395Z"
        />
        <path
          d="M18.0481 9.33433C17.2309 5.98457 14.1489 3.74104 10.5544 3.84726C7.28544 3.94415 4.36449 6.47136 3.75684 9.71049C3.11544 13.1302 5.21784 16.1095 7.10882 16.9952C7.08535 16.3945 7.07876 15.7924 7.08588 15.1898C7.05424 15.144 7.01794 15.1016 6.97753 15.0631C5.8885 14.01 5.32066 12.7294 5.21732 11.2289C4.96872 7.62396 8.55532 4.5856 12.1374 5.39027C14.364 5.89027 15.8941 7.19183 16.5326 9.3522C17.1821 11.5491 16.6175 13.4854 14.9508 15.0983C14.9366 15.1118 14.9218 15.1245 14.9063 15.1364C14.92 15.6224 14.8928 16.1118 14.8928 16.5989C14.8893 16.732 14.8852 16.865 14.8804 16.9978C17.0706 15.8307 18.8638 12.6766 18.0481 9.33433Z"
        />
      </svg>
    `;
  }
};
JbApplePodcastIcon.styles = jb_apple_podcast_icon_css_default;
JbApplePodcastIcon = __decorateClass([
  customElement("jb-apple-podcast-icon")
], JbApplePodcastIcon);

export {
  JbApplePodcastIcon
};
